import { atom } from "recoil"

export type NativeNotificationState = {
    enabled: boolean
    timeScheduledAt: string // e.g. "10:00"
    permissionGranted: boolean
}

export const nativeNotificationStateAtom = atom<NativeNotificationState>({
  key: "nativeNotificationStateAtom",
  default: {enabled: false, timeScheduledAt: "00:00", permissionGranted: true},
})
